<template>
  <ul v-if="invitedLandscapes.length > 0" class="p-5 border-t space-y-4">
    <h2 class="mb-5 text-mono text-xs text-gray-500">
      Pending Invitations
    </h2>
    <li
      v-for="landscape in invitedLandscapes"
      :key="landscape._id"
      class="flex items-start"
      @click="$emit('toHome')"
    >
      <div class="w-2 h-2 mt-5px bg-highlight rounded-full flex-shrink-0" />
      <router-link
        class="ml-3 text-gray-700 text-s font-mono uppercase leading-tight"
        :to="{name: 'home'}"
      >
        {{ landscape.name }}
      </router-link>
    </li>
  </ul>
</template>
<script>
import {mapGetters} from 'vuex'

export default {
  name: 'PendingInvitations',
  computed: {
    ...mapGetters(['invitedLandscapes'])
  }
}
</script>
